/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./RuleChecklist.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var propTypes = {
    visible: PropTypes.bool,
    label: PropTypes.string.isRequired,
    showErrors: PropTypes.bool,
    rules: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        valid: PropTypes.bool.isRequired
    })).isRequired
};
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-ruleChecklist");
exports.RuleChecklist = function RuleChecklist(_a) {
    var label = _a.label, rules = _a.rules, visible = _a.visible, showErrors = _a.showErrors;
    var cssClassNames = [moduleClassName()];
    if (visible) {
        cssClassNames.push(moduleClassName("visible"));
    }
    if (showErrors) {
        cssClassNames.push(moduleClassName("showErrors"));
    }
    return (React.createElement("div", { className: classnames(cssClassNames) },
        React.createElement("div", { className: moduleClassName("content") },
            React.createElement("div", { className: moduleClassName("label") }, label),
            React.createElement("ul", { className: moduleClassName("list") }, rules.map(function (rule) { return (React.createElement("li", { key: rule.label, className: classnames(moduleClassName("item"), rule.valid ? moduleClassName("itemValid") : undefined) },
                React.createElement("div", { className: classnames(moduleClassName("icon"), rule.valid
                        ? moduleClassName("iconCheck")
                        : moduleClassName("iconCross")) }),
                rule.label)); })))));
};
exports.RuleChecklist.propTypes = propTypes;